import { Layout, Menu } from 'antd';
import styled from 'styled-components';
import { ReactNode, useMemo } from 'react';
import { Link, useLocation, Outlet } from 'react-router-dom';
import { Logo } from './logo';

const { Header, Content } = Layout;

const FullScreenLayout = styled(Layout)`
  min-height: 100vh;
	min-width: 100vw;
	background: none;
`;

const FlexHeader = styled(Header)`
  display: flex;
  align-items: center;
  padding: 0;
  background-color: rgb(0, 0, 0, 0.4);
	backdrop-filter: blur(16px);
`;

const StretchMenu = styled(Menu)`
  flex-grow: 1;
`;

const BlurContentBackground = styled(Content)`
  background-color: rgb(0, 0, 0, 0.4);
	backdrop-filter: blur(16px);
`;

interface Page {
	name: string;
	path: string;
	// draws the tab in the error color, e.g. Alerts while an error is unresolved
	danger?: boolean;
}

interface Props {
	pages: Page[];
	// shown above the tabs, e.g. a MaintenanceBanner
	banner?: ReactNode;
	// shown at the end of the tab bar, e.g. the unit's address
	extra?: ReactNode;
}

export const PageLayout = ({ pages, banner, extra }: Props) => {
	const location = useLocation();

	const selectedMenuKeys = useMemo(() => pages
		.filter(({ path }) => location.pathname.startsWith(path))
		.map(({ name }) => name)
		, [location.pathname, pages])

	const menu = useMemo(() => pages.map(({ name, path, danger }) => ({
		key: name,
		label: <Link to={path}>{name}</Link>,
		danger,
	})), [pages]);

	return <FullScreenLayout>
		{banner}
		<FlexHeader>
			<Logo />
			<StretchMenu mode='horizontal' items={menu} selectedKeys={selectedMenuKeys} />
			{extra}
		</FlexHeader>
		<BlurContentBackground>
			<Outlet />
		</BlurContentBackground>
	</FullScreenLayout>
};
